import OnePlatformCommonActions from "@frameworks/web/redux/actions/common/commonActions";
import { DPBILL_DETAIL_REPORT } from "@frameworks/web/redux/interfaces/Reports/iDpBills";
class DpBillsReportActions extends OnePlatformCommonActions {
    getDpBillDetailsReport(dpBillReport, type) {
        this.dispatch({
            type: DPBILL_DETAIL_REPORT,
            payload: { dpBillReport },
            reducerName: type,
        });
    }
}
export default DpBillsReportActions;
